import type { Filter, FilterDataOption, FilterDataMultiSelect } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_TYPE } from '@/app/common/filters/core/filtersTypes.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { isBeachHoliday } from '@/app/common/filters/groups/isBeachHoliday.ts';
import { type TranslationDictionary } from '@/app/components/translations/createTranslationDictionary.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';
import type { SimpleOptionCreate } from '@/app/common/filters/groups/filterGroupsUtils.ts';
import { simpleOptionCreator } from '@/app/common/filters/groups/filterGroupsUtils.ts';

const createEntertainmentOptions = (simpleOptionCreate: SimpleOptionCreate): FilterDataOption[] => [
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.entertainments.zoo', value: '1' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.entertainments.ferris_wheel', value: '2' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.entertainments.oceanarium', value: '3' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.entertainments.dolphinarium', value: '4' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.entertainments.waterpark', value: '5' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.entertainments.lunapark', value: '6' }),
];

type CreateEntertainmentFilters = {
  searchParams: SearchParams;
  translationDictionary: TranslationDictionary;
};
export const createEntertainmentSportsFilters = ({
  searchParams,
  translationDictionary,
}: CreateEntertainmentFilters): Filter[] => {
  const showEntertainmentFilter = isBeachHoliday(searchParams);
  const selectedValues = searchParams[URLParameters.ENTERTAINMENTS]?.split(',') || [];

  const simpleOptionCreate = simpleOptionCreator({ selectedValues, translationDictionary });

  const entertainmentFilter: Filter | undefined = showEntertainmentFilter
    ? {
        name: FILTER_NAME.ENTERTAINMENT,
        type: FILTER_TYPE.MULTI_SELECT,
        data: {
          options: createEntertainmentOptions(simpleOptionCreate),
        } as FilterDataMultiSelect,
      }
    : undefined;

  return [...[entertainmentFilter]].filter((f) => !!f);
};
